import React from 'react'
import { Link } from 'react-router-dom'
import Informacao from '../assets/information.png'
import Historico from '../assets/historia.png'
import Entrega from '../assets/entrega.png'
import Pagamento from '../assets/pagamento.png'
import Pedidos from '../assets/caixa.png'
import './ModalHeader.css';

export default function ModalHeader() {
  return (

    <nav className="menu modal-header">
      <ul>
        <li>
          <Link to="/modal/informacoes" id="informations-btn" className="btn-menu">
            <div className="icon">
              <img src={Informacao} alt="Icone de informação" />
            </div>
            <p className="name">Informações</p>

          </Link>
        </li>

        <li>
          <Link to="/modal/historico" id="historic-btn" className="btn-menu">
            <div className="icon">
              <img src={Historico} alt="Icone de historico" />
            </div>
            <p className="name">Histórico</p>

          </Link>
        </li>

        <li>
          <Link to="/modal/pagamento" id="pagamento-btn" className="btn-menu">
            <div className="icon">
              <img src={Pagamento} alt="Icone de pagamento" />
            </div>
            <p className="name">Pagamento</p>

          </Link>
        </li>

        <li>
          <Link to="/modal/items" id="items-btn" className="btn-menu">
            <div className="icon">
              <img src={Pedidos} alt="Icone de pedidos" />
            </div>
            <p className="name">Pedidos</p>

          </Link>
        </li>

        <li>
          <Link to="/modal/rastreio" id="rastreio-btn" className="btn-menu">
            <div className="icon">
              <img src={Entrega} alt="Icone de entrega" />
            </div>
            <p className="name">Rastreio</p>

          </Link>
        </li>

      </ul>
    </nav>
  )
}